var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.044 5H1.956C1.428 5 1 5.447 1 6c0 .553.428 1 .956 1h10.088c.528 0 .956-.447.956-1 0-.553-.428-1-.956-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.044V.956C8 .428 7.553 0 7 0c-.553 0-1 .428-1 .956v10.088c0 .528.447.956 1 .956.553 0 1-.428 1-.956z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.cee7e5381fbd3719280f3a2e1d35b844.svg";
export { ForwardRef as ReactComponent };